'use es6';

import PropTypes from 'prop-types';
import { jsx as _jsx } from "react/jsx-runtime";
const StatusIndicator = ({
  away,
  size
}) => {
  /**
   * Status indicators are to be green
   * unless the assigned agent is AWAY
   */
  const indicatorStatus = away ? 'status-indicator-grey' : 'status-indicator-green';
  const className = `chat-head-icon chat-head-status ${size} ${indicatorStatus}`;
  return /*#__PURE__*/_jsx("div", {
    className: className
  });
};
StatusIndicator.displayName = 'StatusIndicator';
StatusIndicator.propTypes = {
  away: PropTypes.bool.isRequired,
  size: PropTypes.string.isRequired
};
export default StatusIndicator;